import { connect } from 'react-redux';
import {
  getPages, refreshPages,
  addPage, addTutorialPage, deletePage,
  updatePageAttr,
  addPageVariant, deletePageVariant, clonePageVariant,
  updatePageVariantAttr, updatePageVariantDistribution,
  checkPageSubdomainAvailability,
} from '../actions/page';
import { getDomains, refreshDomains } from '../actions/domain';
import { PageMap } from '../presentation/PageMap';

const mapStateToProps = state => ({
  page: state.page,
  domain: state.domain,
});

const mapDispatchToProps = dispatch => ({
  getPages: () => dispatch(getPages()),
  refreshPages: () => dispatch(refreshPages()),

  addPage: () => dispatch(addPage()),
  addTutorialPage: () => dispatch(addTutorialPage()),
  deletePage: (pageUrlsafe) => dispatch(deletePage(pageUrlsafe)),
  updatePageAttr: (pageUrlsafe, changes) => dispatch(updatePageAttr(pageUrlsafe, changes)),
  checkPageSubdomainAvailability: (pageUrlsafe, subdomain) => dispatch(checkPageSubdomainAvailability(pageUrlsafe, subdomain)),

  getDomains: () => dispatch(getDomains()),
  refreshDomains: () => dispatch(refreshDomains()),

  addPageVariant: (pageUrlsafe) => dispatch(addPageVariant(pageUrlsafe)),
  deletePageVariant: (pageUrlsafe, variantUrlsafe) => dispatch(deletePageVariant(pageUrlsafe, variantUrlsafe)),
  clonePageVariant: (pageUrlsafe, variantUrlsafe) => dispatch(clonePageVariant(pageUrlsafe, variantUrlsafe)),
  updatePageVariantAttr: (pageUrlsafe, variantUrlsafe, changes) => dispatch(updatePageVariantAttr(pageUrlsafe, variantUrlsafe, changes)),
  updatePageVariantDistribution: (pageUrlsafe, variantUrlsafe, value) => dispatch(updatePageVariantDistribution(pageUrlsafe, variantUrlsafe, value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageMap);



// WEBPACK FOOTER //
// ./scripts/containers/PageContainer.jsx